import { Box, BoxProps, Typography, styled } from "@mui/material";
import { prefixClassName } from "@smartrr/shared/components/primitives";
import { IPurchaseState } from "@smartrr/shared/entities/PurchaseState";
import { ScheduledDeliveryGroupWithPurchSt } from "@smartrr/shared/entities/PurchaseState/scheduleUtils";
import { formatAddressInline } from "@smartrr/shared/utils/formatAddressInline";
import { rgba } from "polished";
import React from "react";

import { FutureOrderModule } from "./FutureOrderModule";

interface IInnerOrderGroup extends BoxProps {
  delivery: ScheduledDeliveryGroupWithPurchSt<IPurchaseState>;
  manageSubscriptionModalHandler: () => void;
}
const Wrapper = styled(Box)`
  border: ${props => props.theme.modernSmallCardBorderWidth}px solid
    ${props => props.theme.modernSmallCardBorderColor};
  border-radius: ${props => props.theme.modernSmallCardBorderRadius}px;
  cursor: pointer;
  height: max-content;
  overflow: hidden;
  padding: 15px 20px;
  transition: 0.3s ease-in-out;
  width: 100%;

  :hover {
    background-color: ${props => rgba(props.theme.modernPageBackground!, 0.7)};
  }
`;
export const InnerOrderGroup = ({
  delivery,
  manageSubscriptionModalHandler,
  ...props
}: IInnerOrderGroup): JSX.Element => (
  <Wrapper
    className={prefixClassName("your-subscriptions-wrapper")}
    onClick={() => manageSubscriptionModalHandler()}
    {...props}
  >
    <Typography
      variant="caption1"
      sx={{ marginBottom: "10px", display: "block", width: "auto" }}
      className={prefixClassName("your-subscription-delivery-address")}
    >
      {formatAddressInline(delivery.purchaseState.shippingAddress!)}
    </Typography>
    <FutureOrderModule delivery={delivery} imageSize="small" hideAddons />
  </Wrapper>
);
